exports = module.exports = require("../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".leaflet-cluster-anim .leaflet-marker-icon,\n.leaflet-cluster-anim .leaflet-marker-shadow {\n  transition: transform .3s ease-out, opacity .3s ease-in;\n}\n\n.leaflet-cluster-spider-leg {\n  /* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */\n  transition: stroke-dashoffset .3s ease-out, stroke-opacity .3s ease-in;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib!./~/leaflet.markercluster/dist/MarkerCluster.css
// module id = 137
// module chunks = 0